export var reduxKey = '@@pollEditPopup';
//# sourceMappingURL=constants.js.map